export default __webpack_public_path__ + "/dist/images/campaign-icon.7d61cab238894059580bec56297f2664.svg";